export const formatSuccessRate = (rate?: number): string => (rate ? `${((rate / 100) * 5).toFixed(1)}` : 'N/A');

export const getReferralUrl = (referralId: string): string => {
  const url = new URL(window.location.href);
  url.searchParams.set('referralId', referralId);
  return url.toString();
};

export const getSourceUrl = (source: string): string =>
  window.location.protocol + '//' + window.location.host + '/?source=' + source;
